import { SVGProps } from "react"

const CheckboxActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <rect width={15} height={15} x={0.5} y={0.5} fill="#194F20" rx={2.5} />
    <rect width={15} height={15} x={0.5} y={0.5} stroke="#194F20" rx={2.5} />
    <path
      fill="#fff"
      d="M6.111 10.065 3.624 7.577 2.556 8.645l3.555 3.556 7.333-7.333L12.376 3.8l-6.265 6.265Z"
    />
  </svg>
)
export default CheckboxActive
